import {BreakpointObserver} from '@angular/cdk/layout';
import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Subscription} from 'rxjs';
import {MatSidenav, MatSidenavContent} from '@angular/material/sidenav';
import {CoreService} from 'src/app/services/core.service';
import {AppSettings} from 'src/app/config';
import {filter} from 'rxjs/operators';
import {NavigationEnd, Router, RouterModule, RouterOutlet} from '@angular/router';
import {navItems} from './vertical/sidebar/sidebar-data';
import {AppNavItemComponent} from './vertical/sidebar/nav-item/nav-item.component';
import {MaterialModule} from 'src/app/material.module';
import {CommonModule} from '@angular/common';
import {SidebarComponent} from './vertical/sidebar/sidebar.component';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {TablerIconsModule} from 'angular-tabler-icons';
import {HeaderComponent} from './vertical/header/header.component';
import {AppHorizontalHeaderComponent} from './horizontal/header/header.component';
import {AppHorizontalSidebarComponent} from './horizontal/sidebar/sidebar.component';
import {AppBreadcrumbComponent} from './shared/breadcrumb/breadcrumb.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {RolesService} from 'src/app/services/api/loggedServices/roles/roles.service';
import {BudgetsService} from 'src/app/services/api/budgets/budget.service';
import { formatString as utilFormatString } from 'src/app/shared/string-utils';
import { clearSessionToken } from 'src/app/utils/session-token';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

// for mobile app sidebar

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Component({
  selector: 'app-full',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HttpClientModule,
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    AppBreadcrumbComponent,
  ],
  providers: [HttpClient],
  templateUrl: './full.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
})
export class FullComponent implements OnInit {

  public navItems : any[] = [];

  public sidebar = navItems

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav;
  resView = false;
  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  //get options from service
  options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  appVersion: string;

  constructor(
    private settings: CoreService,
    private router: Router,
    public roleService : RolesService,
    private budgetsService: BudgetsService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.appVersion = this.settings.getOptions().appVersion
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[BELOWMONITOR];
        if (this.options.sidenavCollapsed == false) {
          this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
        }
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
      });

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // This is for scroll to top
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e) => {
        this.content.scrollTo({ top: 0 });
      });
  }

  ngOnInit(): void {
    this.userImg = localStorage.getItem("img") || localStorage.getItem("userImage")
    this.userName = localStorage.getItem("name") || localStorage.getItem("userName")
    setTimeout(() => {
      this.loadSidebar()
    }, 200);
  }

  loadSidebar(){
    var elements : any = []
    this.roleService.getRole().subscribe((data : any) => {
      for(var element of data.elements){
        if(element.permision != "NO") {
          elements.push(element.elementName)
          localStorage.setItem(element.elementName, element.permision)
        }
      }
      for(var side of this.sidebar){
        if(elements.includes(side.code)){

          if (side.code == "REPAIRS-DASH") {
            this.navItems.push({
              navCap : "dashboard"
            })
            this.navItems.push(side)
          } else if(side.code == "MY-DEVICES"){
            this.navItems.push({
              navCap : "management"
            })
            this.navItems.push(side)
          }else if(side.code == "REPAIRS-RMA"
            || side.code == "REPAIRS-PRO"
            || side.code == "REPAIRS-HIS"){
              if(this.navItems[this.navItems.length -1].code != "REPAIRS"){
                this.navItems.push({
                  code : "REPAIRS",
                  displayName: 'repairs',
                  iconName: 'tool',
                  route: 'management/repairs',
                  children : []
                })
                this.navItems[this.navItems.length -1].children.push(side)
              }else{
                this.navItems[this.navItems.length -1].children.push(side)
              }
          } else {
            this.navItems.push(side)
          }
        }
      }
      this.loadBudgetsPendingCounter();
    });
  }

  private loadBudgetsPendingCounter() {
    this.budgetsService.getBudgetsCounters().subscribe({
      next: (res: any) => {
        const pending = Number(res?.pending || 0);
        const budgetsItem = this.navItems.find((item: any) => item?.code === 'BUDGETS');
        if (!budgetsItem) return;

        if (pending > 0) {
          budgetsItem.chip = true;
          budgetsItem.chipContent = String(pending);
          budgetsItem.chipClass = 'bg-light-error text-error';
          budgetsItem.chipTooltipKey = 'budgets.pending_to_respond';
        } else {
          budgetsItem.chip = false;
          budgetsItem.chipContent = '';
          budgetsItem.chipClass = '';
          budgetsItem.chipTooltipKey = '';
        }
      },
      error: () => {
      }
    });
  }

  formatString(str : any) {
    return utilFormatString(str);
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  logout(): void {
    clearSessionToken();
    localStorage.removeItem('mail');
    localStorage.removeItem('name');
    localStorage.removeItem('img');
    this.router.navigateByUrl('/authentication/login');
  }

  public userName : any
  public userImg : any
}
